/* A saved transaction journal means the cart may contain a staged split.
 * Never let the legacy reconciler or checkout consume that intermediate state.
 * This does not recover anything itself: recovery is explicit on the gift page.
 */
(() => {
  const key = 'bc-gift-flow-pending-v1';
  // A real save takes seconds. A journal older than this, or one that cannot
  // be read, is left over from an abandoned tab and must not block checkout.
  const maxAgeMs = 2 * 60 * 60 * 1000;
  const pending = () => {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return false;
      const started = Date.parse(JSON.parse(raw)?.startedAt || '');
      if (!Number.isFinite(started) || Date.now() - started > maxAgeMs) {
        localStorage.removeItem(key);
        return false;
      }
      return true;
    } catch {
      try { localStorage.removeItem(key); } catch { /* storage unavailable */ }
      return false;
    }
  };
  pending();
  const root = window.Shopify?.routes?.root || '/';
  const giftUrl = `${root}cart?view=gifts`;
  const checkoutTarget = '[name="checkout"], a[href*="/checkout"], .shopify-payment-button, shopify-accelerated-checkout-cart';
  const stopCheckout = (event) => {
    if (!pending() || !(event.target instanceof Element)) return;
    const target = event.target.closest(checkoutTarget);
    const checkoutForm = event.type === 'submit' && event.target instanceof HTMLFormElement &&
      (/\/checkout(?:[/?#]|$)/.test(event.target.action) || event.submitter?.matches(checkoutTarget));
    if (!target && !checkoutForm) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(giftUrl);
  };
  document.addEventListener('click', stopCheckout, true);
  document.addEventListener('submit', stopCheckout, true);
})();